import React, { useEffect, useState, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@mui/icons-material/Room";

// #region Components
import Input from "shared/components/FormElements/Input";
import CustomSelect from "shared/components/FormElements/Select";
import Button from "shared/components/FormElements/Button";
import Card from "shared/components/UIElements/Card";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import Modal from "shared/components/UIElements/Modal";
import Marker from "shared/components/UIElements/Marker";
// #endregion Components

// #region Utils
import { VALIDATOR_REQUIRE } from "shared/util/validators";
import { LocationFromAddress } from "shared/util/location";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

import "./Item.css";

const PLocationItem = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);

  const [itemstate, setItemState] = useState();
  const [loadedItem, setLoadedItem] = useState();
  const [markerlocation, setMarkerLocation] = useState();

  const itemId = props.itemid;
  const updateStoreItems = store.UpdatePLocations;

  const ItemType = "pLocation";
  const ItemTypeTR = "Tanımlı Durak";
  const ItemEndPointType = "plocations";

  // #region Standard Interface functions
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const navigate = useNavigate();

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const showDeleteWarningHandler = () => {
    setShowConfirmModal(true);
  };

  const cancelDeleteHandler = () => {
    setShowConfirmModal(false);
  };
  // #endregion Standard Interface functions

  // #region Standard API calls
  const fetchItem = useCallback(async () => {
    try {
      const responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`);
      setLoadedItem(responseData[ItemType]);
      setMarkerLocation(responseData[ItemType].location);
      setItemState(Date.now());
    } catch (err) {}
  }, [sendRequest, itemId]);

  const confirmDeleteHandler = async () => {
    setShowConfirmModal(false);
    try {
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`, "DELETE", null, {
        "Content-Type": "application/json",
      });
      setItemState(Date.now());
      updateStoreItems();
      setLoadedItem(null);
      navigate(`/${ItemEndPointType}`);
    } catch (err) {}
  };
  // #endregion Standard API calls

  useEffect(() => {
    fetchItem();
  }, [itemId, fetchItem]);

  const [formState, inputHandler] = useForm(
    {
      name: { value: "", isValid: true },
      school: { value: null, isValid: true },
      address: { value: null, isValid: true },
    },
    true
  );

  const itemUpdateSubmitHandler = async (event) => {
    event.preventDefault();
    let responseData;

    const savedPLocation = {
      school: formState.inputs.school.value,
      name: formState.inputs.name.value,
      address: formState.inputs.address.value,
      location: markerlocation,
    };

    try {
      responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`,
        "PATCH",
        JSON.stringify(savedPLocation),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      setLoadedItem(responseData[ItemType]);
      setItemState(Date.now());
      updateStoreItems();

      navigate(`/${ItemEndPointType}`);
    } catch (err) {}
  };

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!loadedItem && !error) {
    return (
      <div className="center">
        <Card>
          <h2>{ItemTypeTR} bulunamadı.</h2>
        </Card>
      </div>
    );
  }

  const mapClickHandler = (event) => {
    const currentLocation = { lat: event.lat, lng: event.lng };
    setMarkerLocation(currentLocation);
  };

  const SetLocationFromAddress = async (event) => {
    let location;
    try {
      location = await LocationFromAddress(formState.inputs.address.value);
    } catch (error) {
      setMarkerLocation(null);
      return;
    }
    setMarkerLocation(location);
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <Modal
        show={showConfirmModal}
        onCancel={cancelDeleteHandler}
        header="Emin misiniz?"
        footerClass="place-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDeleteHandler}>
              Hayır
            </Button>
            <Button danger onClick={confirmDeleteHandler}>
              Evet
            </Button>
          </React.Fragment>
        }
      >
        <p>{ItemTypeTR} silme işlemini onaylıyor musunuz? Bu işlem geri alınamaz.</p>
      </Modal>

      {!isLoading && loadedItem && (
        <form key={itemstate} className="item-form" onSubmit={itemUpdateSubmitHandler}>
          <div className="button-container">
            <Button type="button" danger onClick={props.onClose}>
              &#60; Geri
            </Button>
          </div>

          <CustomSelect
            options={store.schoolOptions}
            id="school"
            onInput={inputHandler}
            label="Kurum*"
            validators={[VALIDATOR_REQUIRE()]}
            initialValue={store.schoolOptions.find(
              (school) => school.value.toString() === loadedItem.school.toString()
            )}
            errorText="Zorunlu alan"
          ></CustomSelect>

          <Input
            id="name"
            element="input"
            type="text"
            label="Durak İsmi"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Durak ismi giriniz."
            onInput={inputHandler}
            initialValue={loadedItem.name}
            initialValid={true}
          />

          <Input
            id="address"
            element="input"
            type="text"
            label="Adres"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Adres giriniz."
            initialValue={loadedItem.address}
            initialValid={true}
            onInput={inputHandler}
          />

          <Button type="button" danger onClick={SetLocationFromAddress}>
            Adresten Konumu Getir
          </Button>

          {markerlocation && (
            <div className="map-container">
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyAkGOMUyxOH98l6qetwEChfJDgzMrBiDbc",
                }}
                defaultCenter={markerlocation}
                defaultZoom={16}
                onClick={mapClickHandler}
              >
                <Marker Icon={RoomIcon} lat={markerlocation.lat} lng={markerlocation.lng} />
              </GoogleMapReact>
              {/* <Map center={GetCoordinates(loadedItem.address)} zoom={16} /> */}
            </div>
          )}

          <div className="button-container">
            <Button type="submit" disabled={!formState.isValid}>
              Güncelle
            </Button>

            <Button type="button" danger onClick={showDeleteWarningHandler}>
              SİL
            </Button>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default PLocationItem;
